import React from 'react'
import classes from './Seperator.module.css'

const Seperator = () => {
    return (
        <div className={classes.seperator}>
            
        </div>
    )
}

export default Seperator
